import { usePensionNameValue } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Box, Flex, Text } from "@chakra-ui/react";
import { type AboutDmaxInfoResponse } from "@shared/server";
import DOMPurfiy from "dompurify";

export const AboutIntro = ({ about }: { about: AboutDmaxInfoResponse }) => {
    const { imgList, sector } = { ...about };
    const pensionName = usePensionNameValue();
    const { isMobile, isLaptop } = MEDIA();

    return (
        <Flex as="section" columnGap="24px" position="relative" zIndex={3} flexDir={isMobile ? "column" : "row"}>
            <Flex
                maxW="1600px"
                w="100%"
                margin="0 auto"
                flexDir="column"
                padding={isMobile ? "0 16px" : "0 48px"}
                rowGap={isMobile ? "16px" : "24px"}
            >
                <Flex
                    flexDir="column"
                    marginBottom={isLaptop ? "0" : "8px"}
                    sx={{
                        "& p": {
                            fontFamily: "Noto Serif KR",
                            fontWeight: "140%",
                        },
                    }}
                >
                    <Text fontSize={isMobile ? "16px" : "24px"} color="#6b6b6b">
                        {pensionName.kor}
                    </Text>
                    <Text fontSize={isMobile ? "20px" : "40px"}>{sector.firstLine}</Text>
                </Flex>
                <Flex
                    w="100%"
                    flexDir={isMobile ? "column" : "row"}
                    columnGap={isMobile ? "0" : "48px"}
                    rowGap={isMobile ? "16px" : "0"}
                >
                    <Box
                        background={imgList[0] ? `url(${imgList[0].img_URL}) no-repeat center/cover` : "gray.100"}
                        w={isMobile ? "100" : "55%"}
                        h={isMobile ? "296px" : "568px"}
                    />
                    <Flex w={isMobile ? "100" : "45%"} flexDir="column" rowGap={isMobile ? "32px" : "24px"}>
                        <Box minH={isMobile ? "auto" : "256px"}>
                            <Text mb={isMobile ? "8px" : "16px"}>{sector.secondLine}</Text>
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurfiy.sanitize(sector.thirdLine.replace(/\r?\n/g, "<br />")),
                                }}
                            />
                        </Box>
                        <Flex w="100%" columnGap="24px">
                            {imgList.slice(1, 3).map((img) => (
                                <Box
                                    key={img.img_URL}
                                    background={img ? `url(${img.img_URL}) no-repeat center/cover` : "gray.100"}
                                    _first={{ width: isMobile ? "100%" : "50%", height: isMobile ? "224px" : "376px" }}
                                    _last={{
                                        display: isMobile ? "none" : "block",
                                        width: "50%",
                                        height: isMobile ? "224px" : "248px",
                                    }}
                                />
                            ))}
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};
